import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: '/api',
  timeout: 10000, // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  console.log(error)
  notification.error({
    message: '请求错误',
    description: error,
  })
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use((config) => {
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['token'] = token
    config.headers['clientType'] = 'pc'
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  console.log(response.data)
  // 获取响应头
  const headers = response.headers
  // 获取请求配置
  const config = response.config
  // 判断是否为文件流
  if (headers['content-type'] && headers['content-type'].includes('application/octet-stream') ||
      headers['content-type'] && headers['content-type'].includes('application/vnd.ms-excel') ||
      headers['content-type'] && headers['content-type'].includes('application/pdf') ||
      // 其他文件类型...
      headers['content-disposition'] && headers['content-disposition'].includes('attachment') ||
      config.responseType === 'blob') {
    // 如果是文件，直接返回response（因为文件下载需要完整的response，包括blob数据）
    return response
  } else {
    if (response.data?.status == 2000) {
      const token = storage.get(ACCESS_TOKEN)
      notification.error({
        message: '登录失效或未登录',
        description: '请重新登录',
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 800)
        })
      }
      return Promise.reject(new Error(response.data?.msg || '未知错误'))
    }
    if (response.data?.status != 1 && response.data?.status != 20200) {
      notification.error({
        message: '请求错误',
        description: response.data.msg,
      })
      return Promise.reject(new Error(response.data?.msg || '未知错误'))
    }
    return response.data
  }
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  },
}

export default request

export { installer as VueAxios, request as axios }
